/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Report_Snapshotform_Error_Duplicate2Inputs */

const en_coinvestments_report_snapshotform_error_duplicate2 = /** @type {(inputs: Coinvestments_Report_Snapshotform_Error_Duplicate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An entry for this period already exists`)
};

/**
* | output |
* | --- |
* | "An entry for this period already exists" |
*
* @param {Coinvestments_Report_Snapshotform_Error_Duplicate2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_snapshotform_error_duplicate2 = /** @type {((inputs?: Coinvestments_Report_Snapshotform_Error_Duplicate2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Snapshotform_Error_Duplicate2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_snapshotform_error_duplicate2(inputs)
});
export { coinvestments_report_snapshotform_error_duplicate2 as "coInvestments_report_snapshotForm_error_duplicate" }